/**
 * The pathName for the dialInInfo page.
 *
 * @type {string}
 */
export const DIAL_IN_INFO_PAGE_PATH_NAME = 'static/dialInInfo.html';
/**
 * The identifier of the sound to be played when the status of an outgoing call
 * is expired.
 *
 * @type {string}
 */
export const OUTGOING_CALL_EXPIRED_SOUND_ID = 'OUTGOING_CALL_EXPIRED_SOUND';
/**
 * The identifier of the sound to be played when the status of an outgoing call
 * is rejected.
 *
 * @type {string}
 */
export const OUTGOING_CALL_REJECTED_SOUND_ID = 'OUTGOING_CALL_REJECTED_SOUND';
/**
 * The identifier of the sound to be played when the status of an outgoing call
 * is ringing.
 *
 * @type {string}
 */
export const OUTGOING_CALL_RINGING_SOUND_ID = 'OUTGOING_CALL_RINGING_SOUND';
/**
 * The identifier of the sound to be played when outgoing call is started.
 *
 * @type {string}
 */
export const OUTGOING_CALL_START_SOUND_ID = 'OUTGOING_CALL_START_SOUND';
/**
 * Regex for matching sip addresses.
 */
// eslint-disable-next-line max-len
export const SIP_ADDRESS_REGEX = /^[+a-zA-Z0-9]+(?:([^\s>:@]+)(?::([^\s@>]+))?@)?([\w\-.]+)(?::(\d+))?((?:;[^\s=?>;]+(?:=[^\s?;]+)?)*)(?:\?(([^\s&=>]+=[^\s&=>]+)(&[^\s&=>]+=[^\s&=>]+)*))?$/;
/**
 * Different invite types mapping.
 */
export const INVITE_TYPES = {
    EMAIL: 'email',
    PHONE: 'phone',
    ROOM: 'room',
    SIP: 'sip',
    USER: 'user',
    VIDEO_ROOM: 'videosipgw'
};
export const UPGRADE_OPTIONS_TEXT = 'jaas.8x8.vc';
export const UPGRADE_OPTIONS_LINK = 'https://jaas.8x8.vc/#/plan/upgrade';
/**
 * 邀请弹窗视觉与文案格式常量（对齐客户端「复制邀请」样式）。
 */
/** 弹窗内容区宽度（像素）。 */
export const INVITE_DIALOG_WIDTH_PX = 480;
/** 默认会议时长：1 小时（快速会议无结束时间时的展示兜底）。 */
export const DEFAULT_INVITE_MEETING_DURATION_MS = 60 * 60 * 1000;
/** 会议号展示/复制时的常规分组位数；余 1 时末组 +1（如 234-054-0989）。 */
export const MEETING_ID_GROUP_SIZE = 3;
/** 主操作按钮背景色（淡蓝）。 */
export const INVITE_PRIMARY_BUTTON_COLOR = '#5AA6FF';
/** 主操作按钮悬停色（淡蓝加深）。 */
export const INVITE_PRIMARY_BUTTON_HOVER_COLOR = '#4A95F0';
/** 弹窗标题栏拖动区域高度（像素）。 */
export const INVITE_DIALOG_HEADER_HEIGHT_PX = 48;
